var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasMessages
    ? _c(
        "div",
        { staticClass: "form-field-messages" },
        [
          _vm._l(_vm.messages.error, function(error, errorIdx) {
            return _vm.hasErrorMessages
              ? _c("span", {
                  key: _vm.prefixKey("error", errorIdx),
                  staticClass:
                    "form-field-messages--message form-field-messages--message__error",
                  domProps: { innerHTML: _vm._s(error) }
                })
              : _vm._e()
          }),
          _vm._v(" "),
          _vm._l(_vm.infoMessages, function(info, infoIdx) {
            return _vm.hasInfoMessages
              ? _c("span", {
                  key: _vm.prefixKey("info", infoIdx),
                  staticClass:
                    "form-field-messages--message form-field-messages--message__info",
                  domProps: { innerHTML: _vm._s(info) }
                })
              : _vm._e()
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5932de9a", { render: render, staticRenderFns: staticRenderFns })
  }
}